import React from 'react';
import StyledSpinner from './styles';

interface SpinnerProps {
	className?: string;
	size?: number;
}

const Spinner = ({ className, size }: SpinnerProps) => <StyledSpinner className={className} size={size} />;

export default Spinner;